import {h, Fragment} from "preact"
// import Product from './Product';
import { useEffect } from 'preact/hooks';
import ProductNoGql from './ProductNoGql';
import { useAppState } from '@nosto/preact';

export default function Products() {
  const {
    response: { products },
    loading,
  } = useAppState();
  
  useEffect(() => {
    if (!loading) {
      // Dispatch the custom event when products are loaded
      document.dispatchEvent(new CustomEvent('PLPProducts:built'));
    }
  }, [loading]);

  return (
    <div
      // class="ns-d-flex ns-flex-wrap"
      class="gc_product_grid_main acl_paging_items--wrapper"
      style={loading ? 'opacity: 0.3;' : ''}
    >
      {products.hits.map((hit, index) => {
        return (
          <ProductNoGql
            product={hit}
            key={hit.productId || index}
          />
        );
      })}
    </div>
  );
}
